var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyMedal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "115px",
    height: "114px",
    viewBox: "0 0 115 114",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "92.684717%",
    y1: "12.7100164%",
    x2: "10.8961022%",
    y2: "89.2638357%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7E0DC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Progress-Report_Paid_Lowest-Tier",
    transform: "translate(-671.000000, -382.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(382.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(22.000000, 231.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(267.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.534098,57 C108.534098,52.100261 116.085196,46.2833258 114.867,41.7644749 C113.606112,37.0887448 104.096576,35.7982004 101.707293,31.7045044 C99.2836592,27.5517049 102.885005,18.7496868 99.485097,15.3795808 C96.0856799,12.0094749 87.206466,15.5795106 83.0172456,13.1769481 C78.8876469,10.8084368 77.5857842,1.38157729 72.8692922,0.131894535 C68.3105646,-1.07595377 62.4426136,6.40949516 57.4999028,6.40949516 C52.5571919,6.40949516 46.689241,-1.07595377 42.1307587,0.131894535 C37.4140214,1.38157729 36.1121587,10.8084368 31.98256,13.1769481 C27.7933396,15.5797538 18.9141257,12.0094749 15.5144632,15.3795808 C12.1148007,18.7496868 15.7161464,27.5517049 13.2925129,31.7045044 C10.9032293,35.7982004 1.39369404,37.0887448 0.13305128,41.7642317 C-1.08539012,46.2833258 6.46570787,52.100261 6.46570787,57 C6.46570787,61.899739 -1.08539012,67.7166742 0.13305128,72.2355251 C1.39369404,76.9112552 10.9032293,78.2017996 13.2925129,82.2954956 C15.7163918,86.4482951 12.1148007,95.2503132 15.5144632,98.6204192 C18.9141257,101.990525 27.7933396,98.4204894 31.98256,100.823052 C36.1121587,103.191563 37.4140214,112.618423 42.1305134,113.868105 C46.689241,115.075954 52.5571919,107.590505 57.4999028,107.590505 C62.4426136,107.590505 68.3105646,115.075954 72.8690469,113.868105 C77.5857842,112.618423 78.8876469,103.191563 83.0172456,100.823052 C87.206466,98.4202462 96.0856799,101.990525 99.4853424,98.6204192 C102.88525,95.2503132 99.2836592,86.4482951 101.707293,82.2954956 C104.096576,78.2017996 113.606112,76.9112552 114.867,72.2357683 C116.085196,67.7166742 108.534098,61.899739 108.534098,57",
    id: "Fill-1"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyMedal);
export default __webpack_public_path__ + "static/media/grey-medal.7b3f3685b58d6511875ae582a783afee.svg";
export { ForwardRef as ReactComponent };